import { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';
import classnames from 'classnames';
import styles from './CheckboxInput.module.scss';

interface iProps extends FieldProps {
  title: string;
  disabled?: boolean;
  boxChecked?: (e: boolean) => void;
  displayError?: boolean;
  hrRequired?: boolean;
}

const CheckboxInput = ({ field, form, title, boxChecked, disabled = false, displayError = true, hrRequired = false }: iProps): ReactElement => {
  const { errors, touched, values }: { errors: any; touched: any; values: any } = useFormikContext();
  const hasError = getIn(errors, field.name);
  const touchedError = getIn(touched, field.name);
  const defaultValue = getIn(values, field.name);

  return (
    <>
      <div className={styles.container}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className={styles.inputContainer}>
          <input
            type="checkbox"
            id={field.name}
            className={classnames({
              [styles.checkbox]: true,
              [styles.inputError]: hasError && touchedError,
            })}
            onChange={(e) => {
              if (boxChecked) boxChecked(e.target.checked);
              form.setFieldTouched(field.name);
              form.setFieldValue(field.name, e.target.checked);
            }}
            defaultChecked={defaultValue}
            disabled={disabled}
          />
          <span className={styles.body}>{title}</span>
          <span className={styles.tickContainer} />
        </label>
        {hrRequired && <hr />}
      </div>
      {displayError && <ErrorMessage className={styles.errorMsg} name={field.name} component="span" />}
    </>
  );
};

export default CheckboxInput;
